import { render, staticRenderFns } from "./Impugnacao.vue?vue&type=template&id=d6257ac6&scoped=true"
import script from "./Impugnacao.vue?vue&type=script&lang=js"
export * from "./Impugnacao.vue?vue&type=script&lang=js"
import style0 from "./Impugnacao.vue?vue&type=style&index=0&id=d6257ac6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6257ac6",
  null
  
)

export default component.exports